import React from "react";
import { useMediaQuery } from "react-responsive";
import { useCustomLogo } from "@/states/design.state";
import useDeleteLogo from "@/hooks/common/useDeleteLogo";
import style from "../Logo.module.scss";
import { FiUploadCloud } from "react-icons/fi";
import { HiOutlineTrash } from "react-icons/hi";
import { QrTypeProps } from "@/components/page-modules/builder/__shared/data/builder-qr.type";
type CustomLogoType = {
  handleUploadCustomLogo: (event: React.ChangeEvent<HTMLInputElement>) => void;
  setError: (val: string) => void;
  selectedType: QrTypeProps;
};
const CustomLogo = ({
  handleUploadCustomLogo,
  setError,
  selectedType
}: CustomLogoType) => {
  const isMobile = useMediaQuery({
    query: "(min-width: 1025px)"
  });
  const {
    mutateDeleteLogo
  } = useDeleteLogo(selectedType);
  const {
    customLogo,
    setCustomLogo
  } = useCustomLogo();
  function getLogoName(customLogo: {
    name?: string;
  }) {
    if (!customLogo.name) return "";
    return isMobile || customLogo.name.length <= 20 ? customLogo.name : `${customLogo?.name?.substring(0, 20)}...`;
  }
  const handleDelete = () => {
    if (customLogo.logo) {
      mutateDeleteLogo(customLogo.logo.uuid);
      setCustomLogo({
        logo: null,
        name: ""
      });
      setError("");
    }
  };
  return <div className={style.customLogo_wrap} data-sentry-component="CustomLogo" data-sentry-source-file="index.tsx">
      <div className={style.image_wrap}>
        <img src={customLogo.logo!.image} alt="custom logo" />
        <p className={style.logo_name}>{getLogoName(customLogo)}</p>
      </div>
      <div className={style.actions_wrap}>
        <div className={style.actions_wrap__inputBox}>
          <label htmlFor="logo">
            <FiUploadCloud size={20} color="#616568" data-sentry-element="FiUploadCloud" data-sentry-source-file="index.tsx" />
          </label>
          <input type="file" name="logo" id="logo" onChange={handleUploadCustomLogo} accept=".png,.svg,.jpg,.jpeg" />
        </div>
        <button className={style.delete_btn} onClick={handleDelete}>
          <HiOutlineTrash color="#616568" size={20} data-sentry-element="HiOutlineTrash" data-sentry-source-file="index.tsx" />
        </button>
      </div>
    </div>;
};
export default CustomLogo;